<template>
  <div>
    <router-link :to="editLink" style="text-decoration: none">
      <Button
        type="button"
        icon="pi pi-pencil"
        class="p-button-text p-button-secondary p-mr-1"
      ></Button>
    </router-link>
    <Button
      type="button"
      icon="pi pi-trash"
      class="p-button-text p-button-secondary"
      @click="$emit('delete')"
    ></Button>
  </div>
</template>

<script>
export default {
  name: 'AppRowActions',
  props: {
    editLink: Object,
  },
};
</script>

<style>
</style>